import { render, staticRenderFns } from "./BackVoteList.vue?vue&type=template&id=5944eacd&scoped=true"
import script from "./BackVoteList.vue?vue&type=script&lang=ts"
export * from "./BackVoteList.vue?vue&type=script&lang=ts"
import style0 from "./BackVoteList.vue?vue&type=style&index=0&id=5944eacd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944eacd",
  null
  
)

export default component.exports